import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaColors, SkapaText } from '@inter-ikea-guida/skapa';
import { ColoredButton } from './ColoredButton';
const StyledText = styled(SkapaText) `
  color: ${props => props.$color};
`;
export const GuidaTextButton = ({ label, onClick, selected, dataTestId, aspectRatio = '16/5', subtle, color, selectedColor, textColor = SkapaColors.colourTextAndIcon1, text, ariaLabel }) => {
    return (_jsx(ColoredButton, { label: label, onClick: onClick, selected: selected, subtle: subtle, color: color, selectedColor: selectedColor, dataTestId: dataTestId, aspectRatio: aspectRatio, children: _jsx(StyledText, { "aria-hidden": !!label, "aria-label": ariaLabel, textStyle: 'Heading.L', "$color": textColor, children: text }) }));
};
//# sourceMappingURL=GuidaTextButton.js.map